import React, { Fragment } from "react";

import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  CssBaseline,
  Tabs,
  Tab,
} from "@mui/material";

import { ButtonExit } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function FrequentQuestions(props) {
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent>
          <CssBaseline />
          <Box
            sx={{
              textAlign: "justify",
              background: "#FAFAFA",
              padding: 1,
              fontSize: 14,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  aria-label="basic tabs example"
                  sx={{ background: "#F4F4F4" }}
                >
                  <Tab
                    label="ACEPTACIÓN DE TÉRMINOS Y CONDICIONES"
                    {...a11yProps(0)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                  <Tab
                    label="PROTECCIÓN DE DATOS PERSONALES"
                    {...a11yProps(1)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                  <Tab
                    label="PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS"
                    {...a11yProps(2)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={valueTabs} index={0}>
                <b>ACEPTACIÓN DE TÉRMINOS Y CONDICIONES</b>
                <br></br>
                <br></br>• Todo servicio deberá ser coordinado exclusivamente a
                través de la central de atención telefónica al número:
                096-387-1014. Cualquier atención no autorizada o no registrada
                por dicho canal no contará con cobertura ni derecho a reembolso.
                <br></br>• La vigencia del servicio está sujeta al cumplimiento
                puntual de los pagos por parte del cliente, ya sea en modalidad
                de cuotas mensuales o pago total anticipado.
                <br></br>• El contrato podrá mantenerse vigente por hasta un
                máximo de sesenta (60) días en caso de mora, únicamente respecto
                de la relación contractual, más <b>no respecto del servicio</b>,
                el cual permanecerá suspendido hasta la regularización de los
                pagos. <br></br>• Tiempo de carencia 30 días contados desde la
                fecha de contratación del servicio.
                <br></br>• No se cubrirán tratamientos odontológicos ya
                iniciados al momento de la contratación del servicio.
                <br></br>• No se cubrirán atenciones fuera de la red de
                prestadores ni solicitudes de reembolso.
                <br></br>• No se cubrirán retratamientos, salvo que se indique
                expresamente lo contrario en el recuadro de coberturas.
                <br></br>• La adhesión al presente servicio es libre y
                voluntaria.
                <br></br>• El Servicio de Contact Center será operado por{" "}
                <b>ÚSAME – INNOVATECH S.A.</b> en calidad de{" "}
                <b>Responsable del Tratamiento</b> de los datos personales
                conforme lo establecido en la Ley Orgánica de Protección de
                Datos Personales (LOPDP) y su Reglamento. Por otra parte, la
                atención odontológica general y especializada será prestada por
                la Red de Clínicas Confident a nivel nacional, en calidad de
                Responsable del Tratamiento de datos personales. Cada una de las
                partes será proporcionalmente responsable conforme los datos
                personales que recoja y recopile para el desarrollo de los
                tratamientos necesarios para el correcto desempeño de sus
                funciones y cumplimiento de obligaciones como proveedores de
                servicios.
                <br></br>• El cliente declara que los recursos económicos
                utilizados provienen de fuentes lícitas.
                <br></br>• El cliente declara haber sido debidamente informado
                sobre las condiciones, cobertura, costos, excepciones, vigencia
                y límites del servicio contratado.
                <br></br>• El presente contrato es válido en todo el territorio
                de la República del Ecuador y ampara al titular, sus
                dependientes y/o afiliados adicionales debidamente registrados.
                <br></br>• El titular del contrato deberá ser mayor de edad al
                momento de la firma del mismo.
                <br></br>• El titular es responsable de mantener sus datos
                actualizados, para efectos de notificación y comunicación.
                <br></br>• Para el ingreso de los dependientes y/o, afiliados
                adicionales, en el plan contratado, la edad mínima para el
                ingreso es a partir de los seis (6) meses de edad. La
                permanencia será INDEFINIDA siempre y cuando se mantengan los
                pagos al día.
                <br></br>• Cuando el ingreso es del Núcleo familiar (Titular +
                cónyuge + hijos), no existe límite de beneficiarios.
                <br></br>• Cuando el ingreso es Titular + Familia (Padres,
                hermanos y suegros), el número máximo de beneficiarios es de
                cuatro (4), incluyendo el Titular.
                <br></br>• Todas las asistencias que no se encuentran dentro del
                cuadro de cobertura, cuentan con un descuento por parte del
                prestador y quedan a disposición del cliente el tomar y cancelar
                su respectivo valor.
                <br></br>• Todo servicio que NO se encuentre estipulado
                expresamente en el presente contrato, no será cubierto. Aquellos
                procedimientos no incluidos en el cuadro de coberturas podrán
                ser ofrecidos con descuento por parte del prestador, quedando a
                discreción del CLIENTE su aceptación y pago directo.
                <br></br>• El presente contrato tiene una vigencia indefinida y
                se renovará automáticamente mientras el cliente se mantenga al
                día en sus obligaciones.
                <br></br>• El CLIENTE podrá dar por terminado el presente
                contrato en cualquier momento, sin penalidad, mediante solicitud
                escrita dirigida a ÚSAME INNOVATECH S.A., con una anticipación
                mínima de treinta (30) días calendario. La solicitud deberá
                contener firma del titular, copia de cédula y ser enviada a
                través de los canales oficiales (correo electrónico o entrega
                física). Una vez recibida y validada, la prestación de servicios
                se mantendrá hasta el último día del mes calendario en curso, y
                si existiera un pago anticipado, se devolverá el valor no
                devengado en forma proporcional, deduciendo los costos
                financieros y administrativos correspondientes.
                <br></br>• La terminación del contrato afectará automáticamente
                a todos los dependientes o afiliados registrados, salvo que
                alguno de ellos asuma la titularidad conforme a los
                procedimientos establecidos por ÚSAME INNOVATECH S.A. La empresa
                confirmará por escrito la finalización del contrato y el estado
                de cuenta en un plazo máximo de cinco (5) días hábiles desde la
                recepción válida de la solicitud. No se reconocerán devoluciones
                por periodos ya transcurridos ni por servicios no utilizados
                dentro del mes en curso.
                <br></br>• Autorización de Débito Mensual. El Cliente autoriza
                expresamente a ÚSAME INNOVATECH S.A., a debitar de manera
                automática el importe correspondiente a la suscripción o
                servicio contratado, según el plan elegido, de la cuenta
                bancaria o tarjeta registrada al momento de la contratación.
                <br></br>• Este débito se realizará de forma mensual, en la
                fecha acordada, hasta tanto el cliente decida cancelar el
                servicio conforme a las políticas de cancelación vigentes. El
                Cliente declara estar debidamente informado del valor a ser
                debitado y presta su consentimiento expreso para dicha operación
                recurrente.
                <br></br>• Cualquier modificación en el valor del servicio será
                notificada previamente al cliente, quien tendrá la posibilidad
                de aceptar los nuevos términos o cancelar el servicio antes de
                que se efectúe el siguiente débito.
                <br></br>• Si el cliente presenta información falsa o inexacta
                en el proceso de contratación, perderá de forma automática e
                irrevocable el derecho a los servicios, asumiendo
                responsabilidad civil y/o penal por los perjuicios que dicha
                conducta genere.
                <br></br>• EL CLIENTE autoriza libre, expresa e informadamente a
                ÚSAME INNOVATECH S.A. (“ÚSAME”, en adelante) a utilizar los
                datos personales proporcionados conforme las finalidades
                previstas en este contrato y su política de privacidad. En caso
                de datos personales de terceros, EL CLIENTE garantiza que cuenta
                con la autorización de los terceros cuyos datos proporciona para
                efectos de cobertura, con el objetivo de establecer contacto por
                medio de llamadas telefónicas, mensajes de texto, correo
                electrónico, o cualquier otro medio que sea considerado óptimo
                para el cumplimiento del objeto.
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={1}>
                <b>PROTECCIÓN DE DATOS PERSONALES</b>
                <br></br>
                <br></br>• De conformidad con lo previsto en la Ley Orgánica de
                Protección de Datos, EL CLIENTE libre, voluntaria y
                expresamente, consiente y autoriza a ÚSAME INNOVATECH S.A.
                <br></br>• (ÚSAME) para que utilice y disponga de los datos
                personales que ELCLIENTE le proporcione a través de este
                contrato o por cualquier medio escrito, informático o digital.
                <br></br>• EL CLIENTE proporcionará los datos personales de los
                terceros interesados en acceder al servicio a fin de que sean
                considerados dentro de la cobertura de este, con la observación
                de que los terceros afiliados deberán firmar la autorización
                para el tratamiento de sus datos personales para acceder al
                servicio prestado por la Red de Clínicas Confident a nivel
                nacional.
                <br></br>• ÚSAME declara expresamente que cumple a cabalidad con
                la normativa vigente en materia de protección de datos
                personales para el tratamiento de los datos personales de sus
                clientes.
                <br></br>• ÚSAME declara expresamente que reconoce los derechos
                consagrados al titular de los datos personales, en la
                normativavigente en materia de protección de datos personales.
                <br></br>• ÚSAME declara que en caso de requiriese información
                personal adicional de sus clientes para la prestación efectiva
                delservicio, solicitará la autorización correspondiente para el
                tratamiento de la información de carácter personal de éstos.
                <br></br>• ÚSAME se compromete a tratar los datos con la
                finalidad exclusiva de la prestación del servicio. Una vez
                concluida la prestación del servicio, se compromete a destruir,
                en la medida que lo permita la tecnología, los datos
                proporcionados, asícomo el resultado de cualquier elaboración de
                los mismos y los soportes o documentos en que se halle recogida
                la información o, en su caso, a devolvérselos a EL CLIENTE. La
                conservación y eliminación y/o devolución de los datos
                personales se realizará en cumplimiento de los plazos que
                establece la normativa correspondiente.
                <br></br>• De conformidad con la normativa vigente, ÚSAME asume
                la obligación de proteger los datos personales a los que accedan
                con ocasión del contrato del servicio. Como consecuencia de esta
                obligación legal, entre otras, adoptará las medidas de seguridad
                de tipo técnico, organizativo y de cualquier otra índole, acorde
                a la naturaleza y criticidad de la información personal objeto
                de tratamiento.
                <br></br>• ÚSAME notificará a los titulares cualquier
                vulneración de sus datos personales conforme a los plazos
                establecidos en la LOPDP y su Reglamento.
                <br></br>• La aceptación del presente contrato conlleva la
                aceptación expresa de la política de privacidad de ÚSAME
                disponible en su página web oficial.
                <br></br>
                <br></br>
                El titular de los datos acepta y emite su consentimiento
                unilateral de manera libre y voluntaria para el tratamiento de
                sus datos personales para que sean: recolectados a través de
                nuestros canales electrónicos o por cualquier medio,
                almacenados, procesados, transmitidos y eliminados o para ser
                objeto de cualquier tratamiento o conjunto de tratamientos a
                realizar, ya sea por procedimientos técnicos de carácter
                automatizado, parcialmente automatizado o no automatizados por
                el Comercio o su delegado, con la finalidad de identificar,
                actualizar sus datos y ofrecerle servicios y/o productos a
                través de los canales digitales o cualquier otro medio.
                <br></br>
                <br></br>
                La transmisión y almacenamiento de la información recopilada por
                el Comercio o su delegado, será realizada en la infraestructura
                que este administre, dentro o fuera del territorio ecuatoriano.
                Esta infraestructura puede ser implementada en servidores
                físicos o en la nube de proveedores que cuenten con las debidas
                certificaciones internacionales para el tratamiento de Seguridad
                de la Información.
                <br></br>
                <br></br>
                Adicionalmente, mediante la presente el titular de los datos
                declara conocer y aceptar el Aviso de Política de Privacidad de
                Placetopay en la cual se indican sus derechos, datos tratados y
                las actividades comerciales de los aliados, así como otros datos
                de interés respecto a la protección de datos personales, que se
                encuentran detallados en el sitio web de Placetopay en la ruta
                https://www.placetopay.com/web/politicas-de-privacidad/ ,
                mediante la cual, se podrá solicitar la gestión de derechos o
                consentimientos.
                <br></br>
                <br></br>
                El Comercio o su delegado notificará sobre las actualizaciones
                del Aviso de Política de Privacidad antes mencionado por medio
                de los diferentes canales digitales.
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={2}>
                <b>PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS</b>
                <br></br>
                <br></br>
                En este documento, usted encontrará una sección de preguntas y
                respuestas que le ayudará a sus usuarios a aclarar sus dudas
                sobre los pagos electrónicos procesados a través de Placetopay.
                Recuerde que debe incluirlas en su sitio web.
                <br></br>
                <br></br>
                <b>1. ¿Qué es Placetopay? </b>
                Placetopay es la plataforma de pagos electrónicos que usa ÚSAME
                INNOVATECH S.A. para procesar en línea las transacciones
                generadas en la tienda virtual con las formas de pago
                habilitadas para tal fin.
                <br></br>
                <br></br>
                <b>2. ¿Cómo puedo pagar? </b>
                En la tienda virtual de ÚSAME, usted podrá realizar su pago con
                los medios habilitados para tal fin. Usted, de acuerdo con las
                opciones de pago escogidas por el comercio, podrá pagar a través
                Diners, Discover, Visa y MasterCard; de todos los bancos con
                pago corriente y pagos diferidos, únicamente las tarjetas
                emitidas por Banco Pichincha, Diners, Loja, BGR y Manabí.
                <br></br>
                <br></br>
                <b>
                  3. ¿Es seguro ingresar mis datos bancarios en este sitio web?{" "}
                </b>
                Para proteger tus datos ÚSAME delega en Placetopay la captura de
                la información sensible. Nuestra plataforma de pagos cumple con
                los más altos estándares exigidos por la norma internacional PCI
                DSS de seguridad en transacciones con tarjeta de crédito.
                Además, tiene certificado de seguridad SSL expedido por GeoTrust
                una compañía Verisign, el cual garantiza comunicaciones seguras
                mediante la encriptación de todos los datos hacia y desde el
                sitio; de esta manera, te podrás sentir seguro a la hora de
                ingresar la información de su tarjeta.
                <br></br>
                <br></br>
                Durante el proceso de pago, en el navegador se muestra el nombre
                de la organización autenticada, la autoridad que lo certifica y
                la barra de dirección cambia a color verde. Estas
                características son visibles de inmediato y dan garantía y
                confianza para completar la transacción en Placetopay.
                <br></br>
                <br></br>
                Placetopay también cuenta con el monitoreo constante de McAfee
                Secure y la firma de mensajes electrónicos con Certicámara.
                <br></br>
                <br></br>
                Placetopay es una marca de la empresa colombiana EGM Ingeniería
                Sin Fronteras S.A.S.
                <br></br>
                <br></br>
                <b>
                  4. ¿Puedo realizar el pago cualquier día y a cualquier hora?{" "}
                </b>
                Sí, en ÚSAME podrás realizar tus compras en línea los 7 días de
                la semana, las 24 horas del día a sólo un clic de distancia.
                <br></br>
                <br></br>
                <b>5. ¿Puedo cambiar la forma de pago?</b>
                Si aún no has finalizado tu pago, podrás volver al paso inicial
                y elegir la forma de pago que prefieras. Una vez finalizada la
                compra no es posible cambiar la forma de pago.
                <br></br>
                <br></br>
                <b>
                  6. ¿Pagar electrónicamente tiene algún valor para mí como
                  comprador?{" "}
                </b>
                No, los pagos electrónicos realizados a través de Placetopay no
                generan costos adicionales para el comprador.
                <br></br>
                <br></br>
                <b>7. ¿Qué debo hacer si mi transacción no concluyó?</b>
                En primera instancia deberás revisar si llegó un mail de
                confirmación del pago en tu cuenta de correo electrónico (la
                inscrita en el momento de realizar el pago), en caso de no
                haberlo recibido, deberás contactar a hola@usamebpo.com para
                confirmar el estado de la transacción.
                <br></br>
                <br></br>
                En caso de que tu transacción haya declinado, debes verificar si
                la información de la cuenta es válida, está habilitada para
                compras no presenciales y si tienes cupo o saldo disponible. Si
                después de esto continua con la declinación debes comunicarte
                con Úsame. En última instancia, puedes remitir tu solicitud a
                servicioposventa@placetopay.ec.
                <br></br>
                <br></br>
                <b>8. ¿Qué debo hacer si no recibí el comprobante de pago?</b>
                Por cada transacción aprobada a través de Placetopay, recibirás
                un comprobante del pago con la referencia de compra en la
                dirección de correo electrónico que indicaste al momento de
                pagar. Si no lo recibes, podrás contactar a la línea 023958950 /
                0963166600 o al correo electrónico hola@usamebpo.com, para
                solicitar el reenvío del comprobante a la misma dirección de
                correo electrónico registrada al momento de pagar. En última
                instancia, puedes remitir tu solicitud a
                servicioposventa@placetopay.ec.
                <br></br>
                <br></br>
                <b>9. No me llegó el producto que compré ¿qué hago?</b>
                Debes verificar si la transacción fue exitosa en tu extracto
                bancario. En caso de ser así, debes revisar nuestras políticas
                de envío en el sitio web
                https://usamebpo.com/politica-de-privacidad/ para identificar
                los tiempos de entrega.
              </CustomTabPanel>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
